export default "__VITE_ASSET__CplWrbnl__"